import React from 'react';

import './ThemeBase.scss';
import styles from './Theme.scss';

interface ThemeProps {
  [key: string]: any;
  children?: React.ReactNode;
}

const Theme: React.FC<ThemeProps> = ({ children = [], ...p }) => (
  <div className={styles.theme} {...p}>
    {children}
  </div>
);

export default Theme;
